import * as s from "ramda";
const t = {
  shouldForwardProp: (o) => !o.startsWith("__")
}, d = (o) => ({
  shouldForwardProp: (r) => !s.includes(r, o)
});
export {
  d as noForwardCustomProps,
  t as noForwardProps
};
//# sourceMappingURL=index.js.map
